<template>
    <div>
        <div class="row">
            <div class="col-xs-12 col-md mb-5 mb-md-0">
                <h2
                    class="m-0"
                    v-text="demand.title"
                />
            </div>
            <div class="col-xs-12 col-md text-left text-md-right">
                <el-button
                    round
                    icon="el-icon-back"
                    size="small"
                    @click="$router.push({name: 'demands'})"
                >
                    {{ $t("common.back") }}
                </el-button>
            </div>
        </div>

        <el-divider />

        <div ref="chat" class="chat">
            <input
                id="toggleInfo"
                type="checkbox"
                class="d-none chat--demand_info_handler"
            />
            <div class="chat--demand_info">
                <h3
                    v-text="demand.title"
                />
                <p
                    v-text="demand.description"
                />
            </div>

            <div
                ref="messagesInner"
                class="chat--flex-messages"
            >
                <div class="chat--flex-messages-inner">
                    <div
                        v-for="message in getMessages"
                        :key="message.id"
                        class="message "
                        :class="{'message--me': message.author.id === getUserID}"
                    >
                        <div class="message--owner">
                            <img
                                :src="message.author.photoURL"
                            />
                        </div>
                        <div class="message--body">
                            <div
                                v-autolinker:[options]="message.message"
                                class="message--body-contents"
                                v-text="message.message"
                            />
                            <span
                                v-if="message.author.id === getUserID"
                                class="message--body-time"
                                v-text="$t('view.chats.i_wrote_it', {time: humanReadableDate(message.createTimestamp)})"
                            />
                            <span
                                v-if="message.author.id !== getUserID"
                                class="message--body-time"
                                v-text="$t('view.chats.user_wrote_it', {user: message.author.displayName, time: humanReadableDate(message.createTimestamp)})"
                            />
                        </div>
                        <div class="message--controls">
                            <el-dropdown
                                v-if="message.author.id === getUserID"
                                @command="handleMessageCommand"
                            >
                                <span>...</span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        :command='`{"command":"delete", "item": "${message.id}"}`'
                                    >
                                        {{ $t("view.chats.delete") }}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chat--flex-input-container">
                <div class="chat--flex-input-text">
                    <input
                        v-model="message"
                        type="text"
                        class="chat--flex-input-text-field"
                        :placeholder="$t('view.chats.type_a_message_here')"
                        @keyup.enter="sendMessage"
                    />
                </div>
                <div class="chat--flex-controls">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="$t('view.chats.publish_your_message')"
                        placement="top-end"
                    >
                        <button
                            type="button"
                            class="chat--flex-send-message"
                            :disabled="0 === message.length"
                            @click="sendMessage"
                        >
                            <i class="el-icon-s-promotion" />
                        </button>
                    </el-tooltip>
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="$t('view.chats.learn_more')"
                        placement="top-end"
                    >
                        <label for="toggleInfo">
                            <i class="el-icon-warning-outline" />
                        </label>
                    </el-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ChatsDb                  from "@/firebase/chat-db";
import moment                   from "moment";
import autolinker               from "vue-autolinker";

export default {
    name: "DemandChat",
    head() {
        return {
            title: {
                inner: "."
            }
        };
    },
    directives: {
        autolinker
    },
    data      : () => (
        {
            message        : "",
            demand         : {},
            preventScroll  : false,
            initialScroll  : false,
            chatDB         : null,
            chatSnapshotRef: null,
            options        : {
                mention: "twitter",
                hashtag: "twitter"
            }
        }
    ),
    computed  : {
        ...mapGetters(
            "chats",
            [
                "getMessages"
            ]
        ),
        ...mapGetters(
            "authentication",
            [
                "getUserID"
            ]
        )
    },
    watch     : {
        getMessages() {
            this.$nextTick(() => this.scrollMessagesBottom());
        }
    },
    created() {
        this.chatDB = new ChatsDb(this.$route.params.id);
    },
    beforeDestroy() {
        this.$refs.messagesInner.removeEventListener("scroll", this.listenScrollEvent, false);
        this.chatSnapshotRef();
    },
    async mounted() {
        const {user} = this.$store.state.authentication;
        this.setHeight();
        this.demand = await this.getDemand(this.$route.params.id);


        const title    = document.title.split(" | ");
        title[0]       = this.demand.title;
        document.title = title.join(" | ");

        this.chatSnapshotRef = await this.chatDB.readAllOnChange();

        this.scrollMessagesBottom();
        this.initialScroll = true;

        this.$refs.messagesInner.addEventListener("scroll", this.listenScrollEvent, false);

        if ( user.id === this.demand.author.id ) {
            await this.authorViewedChatMessages(
                {
                    demandId: this.$route.params.id
                }
            );
        }
    },
    methods: {
        ...mapActions(
            "demands",
            [
                "getDemand"
            ]
        ),
        ...mapActions(
            "chats",
            [
                "addChatMessage",
                "deleteMessage",
                "authorViewedChatMessages"
            ]
        ),
        humanReadableDate(date) {
            if (date === null) {
                return date;
            }
            moment.locale("el");
            return moment(date.toDate()).fromNow();
        },
        setHeight() {
            const divider = document.querySelector(".el-divider.el-divider--horizontal");
            const styles  = window.getComputedStyle(divider);
            const height  = window.innerHeight - (
                divider.offsetTop +
                parseInt(styles.marginTop, 10) +
                parseInt(styles.marginBottom, 10) +
                divider.scrollHeight
            );

            this.$nextTick(
                () => {
                    this.$refs.chat.style.height = `${height}px`;
                }
            );
        },
        scrollMessagesBottom() {
            if (this.preventScroll && !this.initialScroll) {
                return false;
            }

            const {scrollHeight}               = this.$refs.messagesInner;
            this.$refs.messagesInner.scrollTop = scrollHeight;

            return false;
        },
        listenScrollEvent(e) {
            this.initialScroll = false;

            if (e.target.scrollTop < (e.target.scrollHeight - e.target.offsetHeight)) {
                this.preventScroll = true;
            } else {
                this.preventScroll = false;
            }
        },
        sendMessage() {
            const demandID  = this.$route.params.id;
            const {message} = this;

            this.$nextTick(() => this.message = "");

            this
                .addChatMessage(
                    {
                        demandId      : demandID,
                        demandAuthorId: this.demand.author.id,
                        message
                    }
                );
        },
        handleMessageCommand(command) {
            const commandBody = JSON.parse(command);

            switch (commandBody.command) {
                case "delete":
                    this.deleteSingleMessage(commandBody.item);
                    break;
                default:
            }
        },
        async deleteSingleMessage(messageID) {
            const demandID = this.$route.params.id;
            await this.deleteMessage(
                {
                    demandID,
                    messageID
                }
            );
        }
    }
};
</script>
